import { Yup } from 'app/components/core/Form';

// Yup's built-in .email() follows RFC 5321, which permits dotless domains
// (`foo@foo`, `root@localhost`) and RFC-invalid dot placement in the local
// part. We require a dot-separated alphabetic TLD instead, and enforce the
// RFC 5321 length caps.
//
//   (?=.{1,254}$)      total length
//   (?=[^@]{1,64}@)    local part length
//   local              no leading, trailing or consecutive dots
//   domain             labels without leading/trailing hyphens, TLD >= 2 alpha
export const EMAIL_REGEX =
    /^(?=.{1,254}$)(?=[^@]{1,64}@)[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/;

// `message` is an i18n key. Mirrors .email()'s excludeEmptyString so optional
// fields keep behaving as before.
export const getEmailSchema = (message) =>
    Yup.string().matches(EMAIL_REGEX, { name: 'email', message, excludeEmptyString: true });
